import React from "react"
import { useTranslation } from "react-i18next"
import { FieldArray, Field, useFormikContext, getIn } from "formik"
import { Stack, Button, IconButton, Grid2 as Grid, Typography } from "@mui/material"
import { Add, Delete } from "@mui/icons-material"
import { FormikTextField } from "./formsHelpers"
import { ACFondo } from "./autocompletes"

export function FondiCollegatiField({ name, label }: { name: string; label: string }) {
  const { t } = useTranslation()
  const { values, errors, setFieldValue } = useFormikContext<any>()
  console.log(456, errors)

  return (
    <div>
      {label && (
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          {label}
        </Typography>
      )}
      <FieldArray name={name}>
        {({ remove, push }) => (
          <div>
            {values[name] &&
              values[name].length > 0 &&
              values[name].map((_item: string[], index: number) => (
                <React.Fragment key={index}>
                  <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{ my: 2 }}>
                    <Grid container spacing={2} flexGrow={1}>
                      <Grid size={3}>
                        <ACFondo
                          label={t("supporto.fondo")}
                          margin="dense"
                          variant="outlined"
                          fullWidth
                          value={values[name][index]?.fondo_collegato || null}
                          onChange={(value) => {
                            setFieldValue(`${name}.${index}.fondo_collegato`, value)
                          }}
                          error={getIn(errors, `${name}.${index}.fondo_collegato`)}
                        />
                      </Grid>

                      <Grid size={3}>
                        <Field
                          label="Collegamento"
                          required
                          name={`${name}.${index}.collegamento`}
                          placeholder="Collegamento"
                          component={FormikTextField}
                          margin="dense"
                          fullWidth
                          size="small"
                        />
                      </Grid>

                      <Grid size={1}>
                        <IconButton
                          title="Elimina riga"
                          sx={{ mt: 1 }}
                          color="error"
                          type="button"
                          onClick={() => {
                            remove(index)
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Stack>
                </React.Fragment>
              ))}

            <Button
              variant="contained"
              type="button"
              size="small"
              onClick={() => push({ codice: "", produttore_pellicola: null })}
              sx={{ mb: 2 }}
            >
              <Add sx={{ mr: 1 }} />
              {t("general.aggiungi_riga")}
            </Button>
          </div>
        )}
      </FieldArray>
    </div>
  )
}
